export default {
    shareReview: {
        title: '分享审核',
        autoApproveHint: '提交后默认 48 小时自动通过审核',
        activityTime: '活动时间',
        empty: '暂无待审核的分享链接',
        tabs: {
            all: '全部',
            pending: '待审核',
            unsubmitted: '未提交',
            approved: '已通过',
            rejected: '已拒绝',
        },
        columns: {
            uid: 'UID',
            platform: '平台',
            link: '链接',
            code: '验证码',
            plays: '播放',
            likes: '点赞',
            shares: '转发',
            submittedAt: '提交时间',
            autoApproveAt: '自动通过期限',
            status: '状态',
            rejectReason: '拒绝理由',
            action: '操作',
        },
        status: {
            pending: '待审核',
            unsubmitted: '未提交',
            approved: '已通过',
            rejected: '已拒绝',
        },
        actions: {
            approve: '通过',
            reject: '拒绝',
            approveConfirm: '确认通过该分享审核？',
            metrics: '修改指标',
        },
        rejectModal: {
            title: '拒绝理由',
            hint: '请填写拒绝原因，用户将收到通知',
            reason: '拒绝原因',
            reasonRequired: '请填写拒绝原因',
            ok: '确认拒绝',
        },
        metricsModal: {
            title: '修改分享指标',
        },
        finalize: {
            button: '确认最终活动数据',
            title: '确认最终活动数据',
            content: '请确认所有数据无误，提交后无法再更改数据，用户积分排行榜将最终定稿。',
            ok: '确认提交',
            disabledHint: '活动结束后才可确认最终数据',
        },
        toast: {
            approved: '已通过',
            rejected: '已拒绝',
            metricsUpdated: '指标已更新',
            finalized: '活动已定稿',
        },
        errors: {
            missingId: '缺少分享记录 ID',
            missingActivityId: '缺少活动 ID',
        },
    },
};
